// extracted by mini-css-extract-plugin
module.exports = {"box":"ScoreBoxes_box__3DmaJ","techName":"ScoreBoxes_techName__1Dhg6","crossTickIcon":"ScoreBoxes_crossTickIcon__Rnmi9","score":"ScoreBoxes_score__3KxYI"};